import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import * as Icons from "lucide-react";
import { Image, Mail, Briefcase, QrCode, Map, Users, ArrowUpRight } from "lucide-react";

const CARDS = [
  { key: "media", label: "Media Assets", icon: Image, path: "/admin/media", color: "cyan" },
  { key: "new_messages", label: "New Messages", icon: Mail, path: "/admin/messages", color: "amber" },
  { key: "applications", label: "Applications", icon: Briefcase, path: "/admin/applications", color: "emerald" },
  { key: "visitor_passes", label: "Visitor Passes", icon: QrCode, path: "/admin/visitors", color: "cyan" },
  { key: "projects", label: "GIS Projects", icon: Map, path: "/admin/projects", color: "amber" },
  { key: "users", label: "Team Members", icon: Users, path: "/admin/roles", color: "emerald" },
];

export default function Dashboard() {
  const [stats, setStats] = useState({});
  const [logs, setLogs] = useState([]);

  const load = useCallback(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data)).catch((e) => console.error(e));
    api.get("/audit-logs").then(({ data }) => setLogs(data.slice(0, 8))).catch((e) => console.error(e));
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-2xl sm:text-3xl font-extrabold text-[#0B3B39]">Operations Dashboard</h1>
        <p className="text-slate-600 mt-1">Real-time overview of your corporate portal.</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-5 mb-8">
        {CARDS.map((c) => {
          const Icon = c.icon;
          return (
            <Link key={c.key} to={c.path} data-testid={`dash-card-${c.key}`} className="oj-card p-6 group">
              <div className="flex items-start justify-between">
                <div className="grid place-items-center w-11 h-11 rounded-xl bg-teal-50 border border-teal-200"><Icon className="w-5 h-5 text-teal-600" /></div>
                <ArrowUpRight className="w-4 h-4 text-slate-500 group-hover:text-amber-300 transition-colors" />
              </div>
              <div className="mt-4 text-3xl font-extrabold text-white font-mono">{stats[c.key] ?? "—"}</div>
              <div className="text-sm text-slate-600 mt-0.5">{c.label}</div>
            </Link>
          );
        })}
      </div>

      <div className="oj-card p-6">
        <h3 className="oj-h3 mb-5">Recent Audit Activity</h3>
        {logs.length === 0 ? <p className="text-slate-500 text-sm">No activity logged yet.</p> : (
          <div className="space-y-3">
            {logs.map((l) => (
              <div key={l.id} className="flex items-center justify-between py-2.5 border-b border-teal-900/40 last:border-0">
                <div className="flex items-center gap-3">
                  <span className="w-2 h-2 rounded-full bg-teal-400" />
                  <div><div className="text-sm text-white font-medium">{l.detail || l.action}</div><div className="text-xs text-slate-500 font-mono">{l.actor}</div></div>
                </div>
                <span className="text-xs text-slate-500 font-mono">{new Date(l.created_at).toLocaleString()}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
